module.exports = __webpack_public_path__ + "img/recording-02.24a03730.svg";